import React from 'react';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalConfirm.css';
import { Button } from '@material-ui/core';
import { LetterX } from 'tabler-icons-react';

export default function ModalIni() {
    const { setOpenIni, openIni, setConfirmIni } = useGeneral();

    const handleCloseAll = () => {
        setOpenIni(false);
    };

    const handleClose = () => {
        setOpenIni(false);
    };

    const body = (
        <div className="modalConf-paper">
            <div className="modalConf-head modalConf-head--ini">
                <div className="modalConf-text">
                    <h4 className="modalConf-text-field">Iniciar Corrida</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleCloseAll}
                        className="modalConf-exit-icon"
                    />
                </div>
            </div>
            <div className="modalConf-body">
                <div className="modalConf-body-text">
                    <h1>Está seguro que desea Iniciar la corrida?</h1>
                </div>
                <div className="modalConf-body-buttons">
                    <div className="modalConf-body-buttons-first">
                        <Button
                            className="modalM-body-buttonS modalM-body-buttonS--ini"
                            onClick={(e) => {
                                handleClose();
                                setConfirmIni(true);
                            }}
                        >
                            <h1>Confirmar</h1>
                        </Button>
                    </div>

                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC modalM-body-buttonC--ini"
                            onClick={(e) => handleClose()}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openIni}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
